import { render, staticRenderFns } from "./EnrollUserToInstitute.vue?vue&type=template&id=56860062"
import script from "./EnrollUserToInstitute.vue?vue&type=script&lang=js"
export * from "./EnrollUserToInstitute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports